"use client";
import React,{useState} from 'react'
import { ProductProvider } from '../components/Productcontext'
import Producthomecontent from '../components/Producthomecontent'
import Footer from '../components/Footer'
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';
import Aseel_cp_earthing from '../components/Aseel_cp_earthing';

import InstallationBanner from '../components/InstallationBanner';
import ProductsubMenu from '../components/ProductsubMenu';

import cpban from '../images/earthing/copper_plated_cp/copper_plated_page_banner.jpg';
import cpban_360 from '../images/earthing/copper_plated_cp/copper_plated_page_banner_360.jpg';
import cpban_tab from '../images/earthing/copper_plated_cp/copper_plated_page_banner_tab.jpg';
import cpban_2x from  '../images/earthing/copper_plated_cp/copper_plated_page_banner@2x.jpg';
// import ban1x from '../images/producthome/product-home-banner.jpg';
// import ban2x from '../images/producthome/product-home-banner@2x.jpg';
const CarboformconductoPage = () => {
    return (
      <div>
           <ProductProvider>
          {/* <PreHeader/>
          <Header/>    
           <Menu/> */}
           <InstallationBanner page="installation" banalt="Copper Plated Earthing Electrodes by Ashlok Safe Earthing Electrode Limited for Optimal Grounding Performance" apostropheBefore="" apostropheAfter="" ban1x={cpban} ban2x={cpban_2x} ban360={cpban_360} bantab={cpban_tab}/>
                <ProductsubMenu/>
          <Aseel_cp_earthing/>
           
           <Footer/>
           </ProductProvider>
      </div>
    )
  }
  
  export default CarboformconductoPage
 
